import kyWithSentry from './helper/kyWithSentry';

import getShortFormVideoKPIUrl from 'url-constructors/ShortFormVideo/getShortFormVideoKPIUrl';
import getShortFormVideoKPICountries from 'url-constructors/ShortFormVideo/getShortFormVideoKPICountries';
import getByUrl from './helper/getByUrl';

const getShortFormVideoCountriesData = (options: any, sortBy: string): any =>
  kyWithSentry
    .get(getShortFormVideoKPICountries({ ...options, sortBy }))
    .json();

const shortFormVideoKPIInterceptor = async (
  input: RequestInfo /* eslint-disable-line */,
  init: RequestInit | undefined /* eslint-disable-line */,
  interceptionData?: any
): Promise<Response> => {
  const {
    compareMode,
    countryIds,
    entityIds,
    entityType,
    filters,
    customRegion,
  } = interceptionData;
  const optionsCountriesViews = {
    entityIds,
    entityType,
    limit: 5,
    sortOrder: 'desc',
    metricType: 'views',
    region: filters?.region,
    countryIds: filters?.country,
    platform: filters?.platform,
    customRegion,
  };

  const optionsCountriesCreations = {
    entityIds,
    entityType,
    limit: 5,
    sortOrder: 'desc',
    metricType: 'creations',
    region: filters?.region,
    countryIds: filters?.country,
    platform: filters?.platform,
    customRegion,
  };

  const urlOptions = {
    countryIds: compareMode === 'country' ? countryIds : filters.country,
    region: filters.region,
    platform: filters?.platform,
    customRegion,
    entityIds,
    entityType,
    compareMode,
  };

  const urlViews = getShortFormVideoKPIUrl({
    ...urlOptions,
    metricType: 'views',
  });

  const urlCreations = getShortFormVideoKPIUrl({
    ...urlOptions,
    metricType: 'creations',
  });

  const shortFormVideoKPIDataViewsFetch = async (): Promise<any> =>
    getByUrl<any>(urlViews);
  const shortFormVideoKPIDataCreationsFetch = async (): Promise<any> =>
    getByUrl<any>(urlCreations);

  const shortFormVideoCountriesViewsDataFetch = async (): Promise<any> =>
    getShortFormVideoCountriesData(optionsCountriesViews, 'countLastWeek');

  const shortFormVideoCountriesCreationsDataFetch = async (): Promise<any> =>
    getShortFormVideoCountriesData(optionsCountriesCreations, 'countLastWeek');

  try {
    const promises: Promise<any>[] = [
      shortFormVideoKPIDataViewsFetch(),
      shortFormVideoKPIDataCreationsFetch(),
      shortFormVideoCountriesViewsDataFetch(),
      shortFormVideoCountriesCreationsDataFetch(),
    ];

    const [
      shortFormVideoKPIViewsData,
      shortFormVideoKPICreationsData,
      shortFormVideoCountriesViews,
      shortFormVideoCountriesCreations,
    ] = await Promise.all(promises);

    return new Response(
      JSON.stringify({
        shortFormVideoKPIViewsData,
        shortFormVideoKPICreationsData,
        shortFormVideoCountriesViews,
        shortFormVideoCountriesCreations,
        urlViews,
        urlCreations,
      })
    );
  } catch (error) {
    const errorInfo = await error.response.json();
    return new Response(
      JSON.stringify({
        reason: {
          error: errorInfo.message,
          errorInfo,
        },
      })
    );
  }
};

export default shortFormVideoKPIInterceptor;
